module.exports = __webpack_public_path__ + "img/one_ad.8604dc66.png";